export default () => {

  window.addEventListener('DOMContentLoaded', () => {

    /**
     * toggle class 'is-active' when on click the triggers
     */
    const toggleActiveTriggers = document.querySelectorAll('.js-toggleActive');
    if (toggleActiveTriggers) {
      toggleActiveTriggers.forEach(toggleActiveTrigger => {
        toggleActiveTrigger.addEventListener('click', () => {
          if(toggleActiveTrigger.classList.contains('is-active')) {
            toggleActiveTrigger.classList.remove('is-active');
          } else {
            toggleActiveTrigger.classList.add('is-active');
          }
        });
      });
    }

    /**
     * Tab
     */
    const tabListElements = document.querySelectorAll('[role="tablist"]');
    const locationHashString = location.hash ? String(location.hash).replace('#', '') : '';
    const locationHashTargetElement = locationHashString ? document.querySelector(location.hash) : false;
    if (tabListElements) {
      tabListElements.forEach(tabListElement => {
        const tabElements: HTMLElement[] = [].slice.call(tabListElement.querySelectorAll('[role="tab"]'));
        const tabPanelElements = tabElements.map(tabElement => {
          return document.querySelector(`#${tabElement.getAttribute('aria-controls')}`);
        });
        tabElements.forEach(tabElement => {
          const currentTabPanelElement = document.querySelector(`#${tabElement.getAttribute('aria-controls')}`);
          if (locationHashString && locationHashTargetElement) {
            if (tabElement.getAttribute('aria-controls') == locationHashString) {
              tabElement.setAttribute('aria-selected', 'true');
            } else {
              tabElement.setAttribute('aria-selected', 'false');
            }
          }
          tabElement.addEventListener('click', () => {
            tabPanelElements.forEach(tabPanelElement => {
              tabPanelElement.setAttribute("aria-hidden", 'true');
            });
            currentTabPanelElement.setAttribute("aria-hidden", 'false');
            tabElements.forEach(eachTabElement => {
              eachTabElement.setAttribute("aria-selected", 'false');
            });
            tabElement.setAttribute("aria-selected", 'true');
          });
        });
        if (locationHashString && locationHashTargetElement) {
          tabPanelElements.forEach(tabPanelElement => {
            if (tabPanelElement === locationHashTargetElement) {
              tabPanelElement.setAttribute('aria-hidden', 'false');
            } else {
              tabPanelElement.setAttribute('aria-hidden', 'true');
            }
          });
        }
      });
    }

    /**
     * Tab (use select box)
     */
    const tabSelectElements: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.js-tabSelect');
    if (tabSelectElements) {
      tabSelectElements.forEach(tabSelectElement => {
        const optionElements: HTMLOptionElement[] = [].slice.call(tabSelectElement.children);
        const displayElement = tabSelectElement.previousElementSibling;
        const tabPanelElements = optionElements.map(optionElement => {
          return document.querySelector(`#${optionElement.value}`);
        });
        if (locationHashString && locationHashTargetElement) {
          optionElements.forEach(optionElement => {
            if (optionElement.getAttribute('aria-controls') === locationHashString) {
              optionElement.selected = true;
              displayElement.textContent = optionElement.textContent;
            } else {
              optionElement.selected = false;
            }
          });
        }
        tabSelectElement.addEventListener('change', () => {
          const currentTabPanelElement = document.querySelector(`#${tabSelectElement.value}`);
          displayElement.textContent = optionElements.filter(optionElement => optionElement.selected)[0].textContent;
          tabPanelElements.forEach(tabPanelElement => {
            tabPanelElement.setAttribute("aria-hidden", 'true');
          });
          currentTabPanelElement.setAttribute("aria-hidden", 'false');
        });
      });
    }

    /**
     * Wrap table elements
     */
    const wrappedTableElements = document.querySelectorAll('.serviceDetails__body table');
    if (wrappedTableElements) {
      wrappedTableElements.forEach(wrappedTableElement => {
        wrappedTableElement.outerHTML = `<div class="u-tableWrapper">${ wrappedTableElement.outerHTML }</div>`
      });
    }

    /**
     * Modal
     */
    const modalTriggerElements = document.querySelectorAll('.js-openModal');
    const closeModalTriggerElements = document.querySelectorAll('.js-closeModal');
    const modalElements = document.querySelectorAll('.l-modal');
    if (modalTriggerElements) {
      modalTriggerElements.forEach(modalTriggerElement => {
        const targetModalElement: HTMLElement = document.querySelector(`#${ modalTriggerElement.getAttribute('aria-controls') }`);
        if (targetModalElement) {
          modalTriggerElement.addEventListener('click', () => {
            modalElements.forEach(modalElement => {
              modalElement.classList.remove('is-active');
            });
            targetModalElement.classList.add('is-active');
            (targetModalElement.querySelector('.l-modal__body') as HTMLElement).style.top = window.scrollY + 60 + 'px';
          })
        }
      });
    }
    if (closeModalTriggerElements && modalElements) {
      closeModalTriggerElements.forEach(closeModalTriggerElement => {
        closeModalTriggerElement.addEventListener('click', () => {
          modalElements.forEach(modalElement => {
            modalElement.classList.remove('is-active');
          });
        })
      })
    }
    
  });

}